export interface AstroDrpScreenshot {
  src: string;
  title: string;
  body: string;
}

export const astroDrpApkPath = '/android/astrodpr/astroDRP.apk';

export const astroDrpScreenshots: AstroDrpScreenshot[] = [
  {
    src: '/android/astrodpr/screenshots/1.jpg',
    title: 'AstroDRP Home',
    body: 'Start from the AstroDRP home experience and explore astrology tools designed for daily guidance and quick insights.',
  },
  {
    src: '/android/astrodpr/screenshots/2.jpg',
    title: 'Personalized Guidance',
    body: 'Get focused astrology guidance based on your profile and current timeline, with a layout optimized for mobile reading.',
  },
  {
    src: '/android/astrodpr/screenshots/3.jpg',
    title: 'Astro Features',
    body: 'Access key features from one place and move quickly between charts, predictions, and practical recommendations.',
  },
  {
    src: '/android/astrodpr/screenshots/4.jpg',
    title: 'Chart Views',
    body: 'Review chart-oriented information in a structured format to understand planetary influences with better clarity.',
  },
  {
    src: '/android/astrodpr/screenshots/5.jpg',
    title: 'Daily Utility',
    body: 'Use AstroDRP as a daily companion with concise insights and actionable suggestions aligned to your routine.',
  },
  {
    src: '/android/astrodpr/screenshots/6.jpg',
    title: 'Detailed Screens',
    body: 'Dive into detailed views for deeper context when you need more than a quick summary.',
  },
  {
    src: '/android/astrodpr/screenshots/7.jpg',
    title: 'User Journey',
    body: 'Follow a smooth journey across app sections with clear navigation and consistent interaction patterns.',
  },
  {
    src: '/android/astrodpr/screenshots/8.jpg',
    title: 'Mobile Experience',
    body: 'Designed as an Android-first app experience, AstroDRP focuses on readability and speed for everyday use.',
  },
];

export const astroDrpBenefits: string[] = [
  'Dedicated Android astrology experience with focused screens for daily and detailed usage.',
  'Simple, mobile-friendly flow to review charts, insights, and guidance quickly.',
  'Built for regular use with clear sections and practical recommendations.',
  'Currently in test mode; full Play Store release is planned soon.',
];

